import { render, staticRenderFns } from "./resetPassword.html?vue&type=template&id=4ce3308f&"
import script from "./resetPassword.js?vue&type=script&lang=js&"
export * from "./resetPassword.js?vue&type=script&lang=js&"
import style0 from "./resetPassword.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports